export default class FraisDepotTh {
  constructor(data) {
    this.id = data.id;
    this.depot = data.depot;
    this.month_id = data.month_id;
    this.depot = data.depot;
    this.operationnel = data.operationnel;
    this.commercial = data.commercial;
    this.marketing = data.marketing;
    this.technique = data.technique;
    this.rge = data.rge;
    this.CDG = data.CDG;
    this.administratif_sav = data.administratif_sav;
    this.dsi = data.dsi;
    this.juridique = data.juridique;
    this.alger = data.alger;
    this.alteo_control_gestion = data.alteo_control_gestion;
    this.comptabilite = data.comptabilite;
    this.RH = data.RH;
    this.bureau_detude = data.bureau_detude;
    this.mairie = data.mairie;
    this.maintenance_pac = data.maintenance_pac;
    this.upcube = data.upcube;
    this.externe = data.externe;
    this.interne = data.interne;
    this.alteo_commercial = data.alteo_commercial;
    this.alteo_supervision = data.alteo_supervision;
    this.detailsShowing = false;
  }
  update(data) {
    this.operationnel = data.operationnel;
    this.commercial = data.commercial;
    this.marketing = data.marketing;
    this.technique = data.technique;
    this.rge = data.rge;
    this.CDG = data.CDG;
    this.administratif_sav = data.administratif_sav;
    this.dsi = data.dsi;
    this.juridique = data.juridique;
    this.alger = data.alger;
    this.alteo_control_gestion = data.alteo_control_gestion;
    this.comptabilite = data.comptabilite;
    this.RH = data.RH;
    this.bureau_detude = data.bureau_detude;
    this.mairie = data.mairie;
    this.maintenance_pac = data.maintenance_pac;
    this.upcube = data.upcube;
    this.externe = data.externe;
    this.interne = data.interne;
    this.alteo_commercial = data.alteo_commercial;
    this.alteo_supervision = data.alteo_supervision;
  }
  static create(data) {
    return new FraisDepotTh(data);
  }
}
